import { render } from "./TerminosCondiciones.vue?vue&type=template&id=d6e50512&scoped=true"
import script from "./TerminosCondiciones.vue?vue&type=script&lang=js"
export * from "./TerminosCondiciones.vue?vue&type=script&lang=js"

import "./TerminosCondiciones.vue?vue&type=style&index=0&id=d6e50512&lang=scss&scoped=true"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6e50512"]])

export default __exports__